/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S5_I1_TextInputs */

const tr_kullanim_s5_i1_text = /** @type {(inputs: Kullanim_S5_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HMK Madde 17-18 uyarınca tarafların tacir veya kamu tüzel kişisi olması halinde doğacak uyuşmazlıklarda Antalya Mahkemeleri ve İcra Daireleri münhasıran yetkilidir.`)
};

const en_kullanim_s5_i1_text = /** @type {(inputs: Kullanim_S5_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pursuant to HMK Madde 17-18, in disputes arising where the parties are merchants or public legal entities, the Antalya Mahkemeleri ve İcra Daireleri have exclusive jurisdiction.`)
};

const de_kullanim_s5_i1_text = /** @type {(inputs: Kullanim_S5_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach HMK Madde 17-18 sind bei Streitigkeiten, die entstehen, wenn die Parteien Kaufleute oder juristische Personen des öffentlichen Rechts sind, ausschließlich die Antalya Mahkemeleri ve İcra Daireleri zuständig.`)
};

const ru_kullanim_s5_i1_text = /** @type {(inputs: Kullanim_S5_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Согласно HMK Madde 17-18, по спорам, возникающим в случае, когда стороны являются коммерсантами или публичными юридическими лицами, исключительной компетенцией обладают Antalya Mahkemeleri ve İcra Daireleri.`)
};

/**
* | output |
* | --- |
* | "Pursuant to HMK Madde 17-18, in disputes arising where the parties are merchants or public legal entities, the Antalya Mahkemeleri ve İcra Daireleri have exc..." |
*
* @param {Kullanim_S5_I1_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s5_i1_text = /** @type {((inputs?: Kullanim_S5_I1_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S5_I1_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s5_i1_text(inputs)
	if (locale === "de") return de_kullanim_s5_i1_text(inputs)
	if (locale === "ru") return ru_kullanim_s5_i1_text(inputs)
	return tr_kullanim_s5_i1_text(inputs)
});